import React, {useContext, useEffect, useMemo, useRef, useState} from "react";
import {Button, Grid, Stack, Switch, TextField, Typography, useTheme} from "@mui/material"
import {AgGridReact} from "ag-grid-react";
import {ColDef} from "ag-grid-community";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import {useLocation, useNavigate} from "react-router-dom";
import {TimePicker} from "@mui/x-date-pickers";
import {useRecoilState} from "recoil";
import AgGridCustomTable from "../../../../../util/component/AgGridCustomTable";
import {generalInfoState} from "../../../search-dms/state";
import {findOpenCloseTimeframe} from "../../dmsDetail.actions";
import {IGeneralTimeframe} from "../../models";
import {SET_SNACKBAR} from "../../../common/utils";
import {GlobalContext} from "../../../../../util/state/GlobalContextProvider";

const OpenCloseTimeframe = () => {
    const {t} = useTranslation(["network", "translation"]);
    const theme = useTheme();
    const navigate = useNavigate();
    const { dispatchGlobalData } = useContext(GlobalContext);
    const location = useLocation();
    const getLastItem = (path:any) => path.substring(path.lastIndexOf('/') + 1)
    let idOnReload = getLastItem(location.pathname);
    const [ rowDataTimeframe, setRowDataTimeframe] = useState<IGeneralTimeframe[]>();
    const gridRef = useRef<AgGridReact>(null);
    const [generalInfo,setGeneralInfo] = useRecoilState(generalInfoState);
    const columnDefs = useMemo<ColDef[]>(() => [
        {field: 'dayOfWeek', headerName: t(`dmsDetail.timeframe.table.dayOfWeek`), valueFormatter: (params) => {
                return t(`dmsDetail.timeframe.dayOfWeek.${params.value}`)}},
        {
            field: 'isOpen',
            headerName: t('dmsDetail.timeframe.table.closeOpen'), cellRenderer: (p: any) => <> <Switch defaultChecked disabled onClick={(e:any) => {
                handleChangeIsOpen(e, p)}} checked={p.value}/></>},
        {field: 'opening', headerName: t("dmsDetail.timeframe.table.opening"), cellRenderer: (p: any) => <> <TimePicker readOnly onChange={(e:any) => {
                handleChangeFrom(e, p)}} renderInput={(params) => <TextField {...params}  />} value={p.value}/></>},
        {field: 'breakFrom', headerName: t("dmsDetail.timeframe.table.breakFrom"), cellRenderer: (p: any) => <> <TimePicker readOnly onChange={(e:any) => {
                handleChangeFrom(e, p)}}  renderInput={(params) => <TextField {...params}  />} value={p.value}/></>},
        {field: 'breakTo', headerName: t("dmsDetail.timeframe.table.breakTo"), cellRenderer: (p: any) => <> <TimePicker readOnly onChange={(e:any) => {
                handleChangeFrom(e, p)}}  renderInput={(params) => <TextField {...params}  />} value={p.value}/></>},
        {field: 'closing', headerName: t("dmsDetail.timeframe.table.closing"), cellRenderer: (p: any) => <> <TimePicker readOnly onChange={(e:any) => {
                handleChangeFrom(e, p)}}  renderInput={(params) => <TextField {...params}  />} value={p.value}/></>},
    ], []);

    const handleChangeFrom = (newValue: any | null, secondValue: any) => {
        secondValue.setValue(newValue);
    };

    const handleChangeIsOpen = (newValue: any | null, secondValue: any) => {
        secondValue.setValue(newValue.target.checked);
    };

    const defaultColDef = useMemo(() => {
        return {
            lockPinned: true,
            editable:false
        }
    }, []);

    const routeChange = () => {
        let path = `/mobility-store/timeframe-panel`;
        if (generalInfo.id != undefined) {
            navigate(path, {
                state: {
                    msId: generalInfo.id
                }
            });
        } else {
            navigate(path, {
                state: {
                    msId: parseInt(idOnReload)
                }
            });
        }
    }

    useEffect(()=> {
        const currentDate = dayjs();
        const reqParams = {
            id: generalInfo.id ? generalInfo.id : parseInt(idOnReload),
            from:  currentDate.format('YYYY-MM-DD'),
            to:  currentDate.add(7, 'day').format('YYYY-MM-DD'),
        };
        findOpenCloseTimeframe(reqParams)
            .then((response: any) => {
                setRowDataTimeframe(response.timeFrame);
            })
            .catch(() => {
                dispatchGlobalData(SET_SNACKBAR.ERROR);
            })
    }, []);

    return(
        <>
                    <Grid item xs={12}>
                        <Stack direction="row" sx={{p: theme.spacing(2), mb: theme.spacing(2)}} justifyContent="space-between" alignItems="space-between">
                            <Typography variant={"h6"} >{t('dmsDetail.openCloseTimeframe.title')}</Typography>
                            <Button onClick={routeChange}>
                                {t('dmsDetail.openCloseTimeframe.button')}
                            </Button>
                        </Stack>
                    </Grid>

                    <AgGridCustomTable
                        gridRef={gridRef}
                        columnDefs={columnDefs}
                        rowData={rowDataTimeframe}
                        pagination={false}
                        gridOptions={
                            {
                                defaultColDef: defaultColDef,
                                onGridReady: (event) => {
                                    event.api.sizeColumnsToFit()
                                }
                            }
                        }
                    />
        </>
    )
}

export default OpenCloseTimeframe;